<template>
    <div class="dialog-box">
        <div class="close" @click="handleClose">
            <i class="iconfont iconguanbi"></i>
        </div>
        <div class="content_box">
            <div class="content">
                <div class="head_go_name">
                    {{ title }}
                </div>
                <div class="message_box">
                    <div class="inp">
                        <el-input
                            type="textarea"
                            :rows="8"
                            placeholder="请输入"
                            v-model="value"
                            v-if="type === 1"
                        >
                        </el-input>
                        <el-input
                            v-else
                            placeholder="请输入"
                            v-model="value"
                            style="margin-top: 10px;"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="btns">
                <el-button class="btn btn2" @click="handleClose">
                    取消
                </el-button>
                <el-button
                    class="btn btn1"
                    @click="handleSave"
                >
                    确认
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'sys-update',
    data() {
        return {
            type: '',
            title: '',
            value: '',
        };
    },
    props: {
        extr: Object,
    },
    created() {
        if (this.extr) {
            this.type = this.extr.type;
            this.value = this.extr.value;
            this.title = this.extr.title;
        }
    },
    methods: {
        handleClose() {
            this.$parent.hide();
        },
        handleSave() {
            this.extr.saveFun(this.value, this.type);
            this.$parent.hide();
        },
    },
};
</script>

<style lang="stylus" scoped>
.dialog-box
    position: relative;
    z-index: 11;
    width 100%;
    height 100%
    .close
        position absolute;
        right 10px;
        top 10px;
        width: 25px;
        height: 25px;
        padding-top 1px;
        display flex;
        justify-content center;
        align-items center;
        cursor pointer;
        .iconguanbi
            font-size 14px;
            color #000;
    .content_box
        box-sizing border-box
        width 100%;
        height 100%
        padding 20px 40px;
        background #fff;
        .content
            height calc(100% - 60px)
            .head_go_name
                margin-bottom 10px
                text-align center
            .file_box
                height 180px
            .message_box
                height 200px
                .title
                    color #999999
                    font-size 18px
                    margin-bottom 10px
        .btns
            height 60px
            display flex;
            justify-content space-around;
            align-items center;
            position absolute
            bottom 0
            left 50%
            transform translate(-50%)
            .btn
                display flex
                justify-content center;
                align-items center;
                width: 140px;
                height: 40px;
                border-radius: 1px;
                border: 1px solid #1577D2;
                color #1577D2;
                font-size 16px;
                &.btn1
                    background: #1577D2;
                    border-radius: 1px;
                    color #fff;
</style>
